import React, { Component } from 'react';
import chatIconUrl from './../../assets/chat-icon.svg';

var TextMessage = function TextMessage(props) {
  return React.createElement(
    'div',
    { className: 'sc-message--text' },
    props.data.text
  );
};

export default TextMessage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chat-window/es/components/Messages/TextMessage.js
// module id = ./node_modules/react-chat-window/es/components/Messages/TextMessage.js
// module chunks = 0